export default {
  AgeFrom: "fromAge",
  AgeTo: "toAge",
  MaritalStatus: "maritalStatus",
  Stance: "stance",
  Message: "message",
};
